var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlueInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atlm_Saleauto_Landing_L2",
    transform: "translate(-382.000000, -1118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i",
    transform: "translate(372.000000, 1118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information-button-copy-12",
    transform: "translate(10.000000, 0.000000)",
    fill: "#0061ED",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9997037,0 C3.13422222,0 0,3.13422222 0,6.9997037 C0,10.8651852 3.13422222,14 6.9997037,14 C10.8651852,14 14,10.8651852 14,6.9997037 C14,3.13422222 10.8651852,0 6.9997037,0 Z M8.45688889,10.8485926 C8.09659259,10.9908148 7.80977778,11.0986667 7.59466667,11.1733333 C7.38014815,11.248 7.13066667,11.2853333 6.84681481,11.2853333 C6.41066667,11.2853333 6.07111111,11.1786667 5.82933333,10.9659259 C5.58755556,10.7531852 5.46725926,10.4835556 5.46725926,10.1558519 C5.46725926,10.0284444 5.47614815,9.89807407 5.49392593,9.76533333 C5.5122963,9.63259259 5.54133333,9.48325926 5.58103704,9.31555556 L6.032,7.72266667 C6.0717037,7.56977778 6.10607407,7.42459259 6.13333333,7.28948148 C6.16059259,7.15318519 6.17362963,7.02814815 6.17362963,6.91437037 C6.17362963,6.7117037 6.13155556,6.56948148 6.048,6.48948148 C5.96325926,6.40948148 5.80385185,6.37037037 5.56622222,6.37037037 C5.45007407,6.37037037 5.33037037,6.38755556 5.2077037,6.4237037 C5.08622222,6.46103704 4.98074074,6.49481481 4.89422222,6.528 L5.01333333,6.03733333 C5.30844444,5.91703704 5.59111111,5.81392593 5.86074074,5.72859259 C6.13037037,5.64207407 6.38518519,5.59940741 6.62518519,5.59940741 C7.05837037,5.59940741 7.39259259,5.70488889 7.62785185,5.91348148 C7.86192593,6.12266667 7.97985185,6.39466667 7.97985185,6.72888889 C7.97985185,6.79822222 7.97155556,6.9202963 7.95555556,7.09451852 C7.93955556,7.26933333 7.90933333,7.42874074 7.86548148,7.57511111 L7.41688889,9.16325926 C7.38014815,9.29066667 7.34755556,9.43644444 7.31792593,9.59940741 C7.28888889,9.76237037 7.27466667,9.88681481 7.27466667,9.97037037 C7.27466667,10.1813333 7.32148148,10.3253333 7.4162963,10.4017778 C7.50992593,10.4782222 7.67407407,10.5167407 7.90637037,10.5167407 C8.016,10.5167407 8.13866667,10.4971852 8.27733333,10.4592593 C8.41481481,10.4213333 8.51437037,10.3875556 8.57718519,10.3585185 L8.45688889,10.8485926 Z M8.37748148,4.40237037 C8.1682963,4.59674074 7.91644444,4.69392593 7.62192593,4.69392593 C7.328,4.69392593 7.07437037,4.59674074 6.86340741,4.40237037 C6.65362963,4.208 6.54755556,3.97155556 6.54755556,3.69540741 C6.54755556,3.41985185 6.65422222,3.18281481 6.86340741,2.98666667 C7.07437037,2.78992593 7.328,2.69214815 7.62192593,2.69214815 C7.91644444,2.69214815 8.16888889,2.78992593 8.37748148,2.98666667 C8.58666667,3.18281481 8.69155556,3.41985185 8.69155556,3.69540741 C8.69155556,3.97214815 8.58666667,4.208 8.37748148,4.40237037 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 10,
    height: 18
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueInfoIcon);
export default ForwardRef;